var map = {
	"./arrow-bottom.svg": "4977",
	"./arrow-right-white.svg": "e9dd",
	"./arrow-right.svg": "f21f",
	"./mint-tokens.png": "b37f",
	"./receive-yield.png": "ba7a",
	"./use-in-defi.png": "e8f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6863";